import { Component } from '@angular/core';

@Component({
    selector: 'app-details-toolbar-additional-info',
    template: `
        <ng-content></ng-content>
    `
})
export class DetailsToolbarAdditionalInfoComponent {

}
